import { NewMessageForm } from '@src/main/modules/messages/ui/mailbox/components/new-message/NewMessageForm';
import ContentCard from '@src/main/shared/ui/components/card/ContentCard';
import HeaderTitle from '@src/main/shared/ui/components/header/HeaderTitle';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const NewMessage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const messageId = params.get('messageId') ?? '';

  return (
    <ContentCard>
      <HeaderTitle title={t('messages.mailbox.newMessage.title')} />
      <NewMessageForm messageId={messageId} />
    </ContentCard>
  );
};

export default NewMessage;
